// DetailsRow.js
import React from "react";

export default function Row({ label, value, isLink = false }) {
  return (
    <div className="kv-row">
      <div className="kv-label">{label}</div>
      <div className={`kv-value ${isLink ? "kv-link" : ""}`}>
        {value ?? "-"}
      </div>
    </div>
  );
}
